module.exports = __webpack_public_path__ + "static/media/branding-img21.181899ae.jpg";